import { Breadcrumbs } from "@/components/Breadcrumbs";
import { Link, type ToOptions } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";
import React from "react";
import { twMerge } from "tailwind-merge";
import { StickyElement } from "./StickyElement";

// TODO: maybe a more flexible abstraction of this component
type Props = {
  title?: string;
  backLinkOptions?: ToOptions;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  onBackButtonClick?: (e: React.MouseEvent) => void;
  sticky?: boolean;
  breadcrumbs?: React.ComponentProps<typeof Breadcrumbs>;
};

export function PageHeader({
  title,
  backLinkOptions,
  onBackButtonClick,
  actions,
  className,
  children,
  sticky = true,
  breadcrumbs,
}: Props) {
  const finalClassName = twMerge(
    "shrink-0 p-8 pb-0 xl:p-14 xl:pb-0",
    className,
  );

  const renderInnerContent = () => (
    <div className="border-separator h-12 w-full xl:h-16">
      <div className="flex h-4 w-full items-center gap-x-4">
        {children ?? (
          <div className="flex min-w-0 items-center gap-x-2">
            {backLinkOptions && (
              <Link
                onClick={onBackButtonClick}
                {...backLinkOptions}
                className="group text-theme-on-background hover:text-theme-on-background/90 flex items-center gap-x-2 rounded-xs focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-white"
              >
                <ChevronLeft className="-mx-1.5 size-5" />
                <span className="text-sm/[16px] font-medium uppercase">
                  Tilbage
                </span>
              </Link>
            )}

            {backLinkOptions && (title || breadcrumbs) && (
              <div className="border-theme-outline-variant h-4 border"></div>
            )}

            {title && (
              <span className="block text-sm/[16px] font-medium uppercase transition-[color] duration-200">
                {title}
              </span>
            )}

            {breadcrumbs && <Breadcrumbs {...breadcrumbs} />}
          </div>
        )}
        {actions && (
          <div className="ml-auto flex items-center gap-x-4">{actions}</div>
        )}
      </div>
    </div>
  );

  return sticky ? (
    <StickyElement
      className={finalClassName}
      stickyProps={{
        className: "bg-theme-background rounded-t-lg",
      }}
    >
      {renderInnerContent()}
    </StickyElement>
  ) : (
    <div className={finalClassName}>{renderInnerContent()}</div>
  );
}
